import './marker.scss';
import { CONVERSIONS } from '@constants';
import { store } from '@redux';
import * as L from 'leaflet';
import { noop } from '../../../../utils';

const getAssetReading = (asset, abilityName) => {
  return asset.readings?.find((reading) => reading.ability === abilityName);
};

const createStationaryAssetMarker = (sAsset, { reading }) => {
  const asset = sAsset.sAsset;
  if (!sAsset.location) return null;

  let markerColor =
    asset.isOnline === 'Online'
      ? 'var(--c-primary)'
      : asset.isOnline === 'Offline'
      ? 'var(--danger)'
      : asset.isOnline === 'NoBeacons'
      ? 'var(--nav-text)'
      : 'var(--alt1)';
  let value = '';

  const selectedReading = getAssetReading(asset, reading);

  const rawValue =
    selectedReading?.value ??
    selectedReading?.reading ??
    selectedReading?.rawValue ??
    asset[reading]?.mean;

  if (rawValue == null || isNaN(rawValue)) {
    value = '--';
  } else if (reading === 'Temperature') {
    const { temp } = store.getState().userPrefs;

    value =
      temp === 'Fahrenheit' || temp === 'F'
        ? CONVERSIONS.CtoF(Number(rawValue))
        : Number(rawValue).toFixed(1);
  } else {
    value = Number(rawValue).toFixed(1);
  }

  let displayValue =
    value === undefined || value === null || value === '' ? '--' : value.toString();

  const marker = L.marker([sAsset.location.y, sAsset.location.x], {
    icon: L.divIcon({
      html: `<div style='background-color: ${markerColor};' class='marker-pin'></div><b className='fs-xs'>${displayValue}</b>`,
      iconSize: [30, 42],
      iconAnchor: [15, 42],
      popupAnchor: [-1, -12],
      className: 'custom-div-icon',
    }),
    title: asset.assetName,
  });

  marker.sAssetIndex = sAsset.index;

  if (asset.assetName) {
    marker.bindPopup(`<b>${asset.assetName}</b>`);
  }

  return marker;
};

const createStationaryAssetLayers = (sAsset, { reading }) => {
  const layers = [];
  if (!sAsset.isVisible) return layers;

  const layer = createStationaryAssetMarker(sAsset, { reading });
  if (layer) {
    layer.data = sAsset;
    layers.push(layer);
  }

  return layers;
};

const createStationaryAssetsLayerArray = (assets, { reading, onSetLayers }) => {
  if (!assets) return [];

  const layers = [];
  for (const asset of assets) {
    const assetLayers = createStationaryAssetLayers(asset, { reading });
    onSetLayers(assetLayers);
    layers.push(...assetLayers);
  }
  return layers;
};

const createStationaryAssetsLayerGroup = (assets, { reading = '', onSetLayers = noop } = {}) => {
  return new L.FeatureGroup(createStationaryAssetsLayerArray(assets, { reading, onSetLayers }));
};

export { createStationaryAssetsLayerGroup };
